




























































































































































































































import { addItemToLocalStorage, convertDictionaryToList, existParams, getItemFromLocalStorage, getItemFromLocalStorageParsed, getParameterFromUrl, PRIVILEGE_KEYS, removeItemFromLocalStorage } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import MultipleSelect from '../../core/components/MultipleSelect.vue';
import Button from '../../core/components/Button.vue';
import FilterByDateRange from '../../core/components/FilterByDateRange.vue';
import Combobox from '../../core/components/Combobox.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { boolOptions, farmingYears, seasonOptions } from '../options';
import { HarvestRanchListFilters, InsuranceFilters, SowingRanchListFilters } from '../api/models';
import { ComboSelectedOption, defaultSelectedOption, IdAndNumber, paramsOptions } from '../../../features/core/models';
import { watch } from 'fs';
import { InsuranceServices } from '../api/InsuranceServices';
import { sowingRanchsProperties } from '../api/sowingModels';
import { farmingInfo, harvestRanchProperties } from '../api/harvestModels';
import { farmingsListProperties } from '../farming_models';


@Component({
    components: {
        Button,
        Combobox,
        MultipleSelect,
        FilterByDateRange
    }
})
export default class TableFilters extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: null}) propertiesData: object;
    @Prop({
        default: [
            'insurance_company', 
            'companies', 
            'season',
            'start_date',
            'end_date',
            'year',
            'finished',
            'closing_condition',
            'policy',
            'resowing',
            'state',
            'farming',
            'insurance_farming',
            'progress'
        ]
    }) visibleFields: string[];
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: false}) optionsFromResponse: farmingsListProperties | harvestRanchProperties | sowingRanchsProperties;

    yearsOptions: Array<defaultSelectedOption> = [];
    stateOptions: defaultSelectedOption[]  = [];
    closingConditionsOptions: defaultSelectedOption[]  = [];
    policyOptions: IdAndNumber[]  = [];
    farmingOptions: farmingInfo[] = [];
    insuranceFarmingOptions: farmingInfo[] = [];

    loadingProperties: boolean = false;
    optionsInsuranceCompany: Array<object> = [];
    cropTypeOptions: Array<object> = [];
    seasonOptions: Array<object> = seasonOptions;
    booleanOptions: Array<object> = boolOptions;
    noOptionsFound: string = 'No hay opciones que coincidan con la búsqueda';
    seeOnlyResowing: boolean = false;
    seeOnlyProgress: boolean = false;
    filtersInsuranceCarrierSelected: any = null;
    filtersCompanySelected: any = null;
    filtersInsuranceCarrierRV: boolean = false;
    filtersInsuranceCompaniesSelected: Array<object>[] = [];
    filtersZafraTypeSeason: any = null;
    filtersZafraTypeRv: boolean = false;
    filtersStateValue: any = null;
    filtersCropType: any = null;
    filtersPolizaSelected: any = null;
    closingConditionSelected: any = null;
    farmingSelected: any = null;
    filtersZafraYear: any = null;
    filtersInsuranceFarmingSelected: any = null;
    filtersZafraYearRv: boolean = false;
    cropTypeRv: boolean = false;
    farmingSelectedRV: boolean = false;
    filtersClosedSelected: object | null = null;
    filtersClosedSelectedRv: boolean = false;
    filtersStateRv: boolean = false;
    filtersPolizaRV: boolean = false;
    closingConditionRV: boolean = false;
    farmingsRv: boolean = false;
    insuranceFarmingSelectedRV: boolean = false;
    insuranceFarmingSelected: any = null;
    visibleModalFilterByDateRange: boolean = false;
    filtersDateRangeSelected: any = [];
    counter: number = 0;

    @Watch('optionsFromResponse', {immediate: true, deep:true})
    observableOptionsFromResponse(){
        this.setOptionsFromResponseList();
    }

    fieldIsVisible(key: string): boolean {
        return this.visibleFields.includes(key);
    }

    setOptionsFromResponseList(){
        /* Cargo opciones para los campos segun la respuesta del WS*/
        if(this.optionsFromResponse && this.optionsFromResponse.years){
             this.setYearsOptions(this.optionsFromResponse.years);
             this.preselectYearFirstTime()
        }
        if(this.optionsFromResponse && this.optionsFromResponse['farmings']){
            this.farmingOptions = this.optionsFromResponse['farmings'];
        }
        if(this.optionsFromResponse && this.optionsFromResponse['policies']){
            this.policyOptions = this.optionsFromResponse['policies'];
        }
        if(this.optionsFromResponse && this.optionsFromResponse['states']){
            //si state options es un array de strings, lo convierto a un array de objetos
            if(typeof this.optionsFromResponse['states'][0] === 'string'){
                this.stateOptions = this.optionsFromResponse['states'].map((state, index) => {
                    return {
                        id: index == 0 ? 1 : 0,
                        value: state
                    }
                })
            }else{
                this.stateOptions = this.optionsFromResponse['states'];
            }
        }
        if(this.optionsFromResponse && this.optionsFromResponse['insurance_farmings']){
            this.insuranceFarmingOptions = this.optionsFromResponse['insurance_farmings'];
        }
        if(this.optionsFromResponse && this.optionsFromResponse['crop_types']){
            this.cropTypeOptions = convertDictionaryToList(this.optionsFromResponse['crop_types']);
        }
    }

    preselectYearFirstTime(){
        if(this.filtersInsuranceCarrierSelected !== null){
            this.counter += 1;
        }

        
        if(this.counter === 1){
            //preselect new year first
            if(this.yearsOptions.length){
                this.updateFiltersZafraYear(this.yearsOptions[this.yearsOptions.length - 1]);
            }
        }
    }

    setYearsOptions(options){   
        this.yearsOptions = [];
        
       if(options.length){
            this.yearsOptions = options.map(function (year, index){
                return {
                    id: index,
                    value: year
                }
            })
        }

       
    }
    



    updateFiltersDateRange(dateRange){
        this.filtersDateRangeSelected = dateRange;
    }


    mounted(){
        let self = this;
        this.$nextTick(() => {
            self.setOptionsFromResponseList();
            self.loadOptions();
        });
    }

    loadOptions(){
         this.optionsInsuranceCompany = this.propertiesData['insurance_companies'];
         this.closingConditionsOptions = this.propertiesData['closing_conditions_options'];
         this.preselectInsuranceCompany(this.optionsInsuranceCompany);
    }

    updateFiltersInsuranceCarrierSelected(value) {
        this.filtersInsuranceCarrierSelected = value;
        if (value !== null) {
            addItemToLocalStorage('mv_filters_aseguradora', value);
        } else {
            this.updateFiltersCompanySelected(null);
            removeItemFromLocalStorage('mv_filters_aseguradora');
        }
        this.clearInsuranceCompanies();
    }

    preselectInsuranceCompany(optionsInsuranceCompany){
        /* Preseleccionar empresa aseguradora */
        let insuranceCompanyIdFromUrl = getParameterFromUrl(paramsOptions.insurance_company) !== null 
        ? Number(getParameterFromUrl(paramsOptions.insurance_company)) : null

        let insuranceCompanyFromStorage = getItemFromLocalStorage('mv_filters_aseguradora') !== null
                ? getItemFromLocalStorageParsed('mv_filters_aseguradora')['id']
                : null;
        let insuranceCompanyId:number | null = insuranceCompanyFromStorage;

        if(existParams() && insuranceCompanyIdFromUrl !== null){
            insuranceCompanyId = insuranceCompanyIdFromUrl;
        }

        if(insuranceCompanyId !== null){
            //si hay una aseguradora guardada en el local storage, la preselecciono
            let optIndex = optionsInsuranceCompany.findIndex(item => item['id'] == insuranceCompanyId);
            this.updateFiltersInsuranceCarrierSelected(optionsInsuranceCompany[optIndex]);
        }else{
            //si no hay una aseguradora guardada en el local storage, preselecciono la primera
            this.updateFiltersInsuranceCarrierSelected(optionsInsuranceCompany[0])
        }
    }

    preselectFarming(){
        /* Preseleccionar Zafra */
        let farmingId = getParameterFromUrl(paramsOptions.farming_id) !== null 
        ? Number(getParameterFromUrl(paramsOptions.farming_id)) : null

        if(existParams() && farmingId !== null){
            let optIndex = this.farmingOptions.findIndex(item => item['id'] == farmingId);
            if(optIndex !== -1){
                this.updateFarmings(this.farmingOptions[optIndex])
            }
        }
    }

    clearInsuranceCompanies() {
        this.filtersInsuranceCompaniesSelected = [];
        this.multipleInsuranceCompanySelector.clearOptionsSelected();
    }

    updateFiltersInsuranceCarrierRV(value) {
        this.filtersInsuranceCarrierRV = value;
    }


    updateFiltersCompanySelected(value) {
        this.filtersCompanySelected = value;
    }
    updateFiltersInsuranceFarming(value) {
        this.filtersInsuranceFarmingSelected = value;
    }

    updateFiltersInsuranceFarmingSelectedRV(value) {
        this.insuranceFarmingSelectedRV = value;
    }
    updateClosingConditionSelected(value) {
        this.closingConditionSelected = value;
    }
    updateClosingConditionSelectedRv(value) {
        this.closingConditionRV = value;
    }

    get multipleInsuranceCompanySelector(): HTMLFormElement {
        return this.$refs.iaCompany as HTMLFormElement;
    }

    get getOptionsCompany() {
        if (this.filtersInsuranceCarrierSelected == null) {
            return [];
        }

        return this.filtersInsuranceCarrierSelected['secured_companies'];
    }

    get placeholderInsuranceCompany() {
        return this.filtersInsuranceCarrierSelected == null ? 'Seleccione una aseguradora' : 'Seleccionar';
    }


    customLabelSowingSelector(option) {
        if (option['insurance_farming'] && option['insurance_farming']['company']) {
            return `${option['insurance_farming']['company']['name']} - ${option['name']}`;
        }
        return `${option['name']}`;
    }

    filtersSelectInsuranceCompany(itemToAdd) {
        this.filtersInsuranceCompaniesSelected.push(itemToAdd);
    }

    filtersRemoveInsuranceCompany(itemToRemove) {
        this.filtersInsuranceCompaniesSelected = this.filtersInsuranceCompaniesSelected.filter(
            item => item['id'] !== itemToRemove.id
        );
    }

    updateFiltersFarming(value) {
        this.farmingSelected = value;
    }

    updateFiltersZafraSeason(value) {
        this.filtersZafraTypeSeason = value;
    }
    updateFiltersState(value) {
        this.filtersStateValue = value;
    }
    updateFiltersStateRV(value) {
        this.filtersStateRv = value;
    }
    updateCropTypeSelected(value) {
        this.filtersCropType = value;
    }
    updateCropTypeSelectedRv(value) {
        this.cropTypeRv = value;
    }
    updateFiltersPoliza(value) {
        this.filtersPolizaSelected = value;
    }
    updateFiltersPolizaRV(value) {
        this.filtersPolizaRV = value;
    }

    updateFiltersZafraSeasonRV(value) {
        this.filtersZafraTypeRv = value;
    }

    updateFiltersZafraYear(value) {
        this.filtersZafraYear = value;
    }
    updateFarmings(value) {
        this.farmingSelected = value;
    }

    updateFarmingsRv(value) {
        this.farmingsRv = value;
    }

    updateFiltersZafraYearRV(value) {
        this.filtersZafraYearRv = value;
    }

    updateFiltersCloseSelected(value){
        this.filtersClosedSelected = value;
    }
    updateFiltersCloseRv(value){
        this.filtersClosedSelectedRv = value;
    }

    visibilityModalFilterByDateRange(value) {
        this.visibleModalFilterByDateRange = value;
    }

    @Watch('filtersInsuranceCarrierSelected')
    @Watch('filtersInsuranceCompaniesSelected')
    @Watch('filtersZafraTypeSeason')
    @Watch('filtersZafraYear')
    @Watch('filtersClosedSelected')
    @Watch('filtersDateRangeSelected')
    @Watch('seeOnlyResowing')
    @Watch('closingConditionSelected')
    observableFilters() {
        if(this.isSowing){
             this.searchAction();
        }
    }
    
    @Watch('filtersInsuranceCarrierSelected')
    @Watch('filtersInsuranceCompaniesSelected')
    @Watch('filtersZafraTypeSeason')
    @Watch('filtersZafraYear')
    @Watch('filtersClosedSelected')
    @Watch('filtersDateRangeSelected')
    @Watch('filtersPolizaSelected')
    @Watch('filtersStateValue')
    @Watch('seeOnlyProgress')
    @Watch('farmingSelected')
    @Watch('filtersInsuranceFarmingSelected')
    @Watch('closingConditionSelected')
    @Watch('filtersCropType')
    observableHarvestFilters() {
        if(!this.isSowing){
             this.searchAction();
        }
    }
    

    @Emit()
    searchAction():SowingRanchListFilters | HarvestRanchListFilters | undefined{
        if(this.loadingProperties) {
            return
        } 

        let filters:InsuranceFilters = {};
        // console.log("insurance_company", this.filtersInsuranceCarrierSelected);
        if(this.filtersInsuranceCarrierSelected !== null){
            filters.insurance_company = this.filtersInsuranceCarrierSelected['id'];
        }

        if(this.filtersInsuranceCompaniesSelected.length > 0){
            filters.companies = this.filtersInsuranceCompaniesSelected.map(item => item['id']);
        }

        if(this.filtersZafraTypeSeason !== null){
            filters.season = this.filtersZafraTypeSeason['id']
        }
        if(this.filtersZafraYear !== null){
            filters.year = this.filtersZafraYear['value']
        }
        if(this.filtersClosedSelected !== null){
            filters.finished = this.filtersClosedSelected['value']
        }
        if(this.filtersDateRangeSelected.length > 0){
            filters.start_date = this.filtersDateRangeSelected[0];
            filters.end_date = this.filtersDateRangeSelected[1];
        }

        if(this.closingConditionSelected !== null){
            filters.closing_condition = this.closingConditionSelected['id']
        }

        if(filters.start_date === ''){
            delete filters.start_date;
        }
        if(filters.end_date === ''){
            delete filters.end_date;
        }

        if(this.filtersCropType !== null){
            filters['harvest_type'] = this.filtersCropType['id']
        }



        if(this.isSowing){
            let sowingFilters: SowingRanchListFilters = {
                ...filters,
                resowing: this.seeOnlyResowing
            }
            return sowingFilters
        }else{
            let harvestFilters: HarvestRanchListFilters = {
                ...filters,
                progress: this.seeOnlyProgress,
            }

            if(this.filtersPolizaSelected !== null){
                harvestFilters.policy = this.filtersPolizaSelected['id']
            }
            if(this.filtersStateValue !== null){
                harvestFilters.state = this.filtersStateValue['id']
            }
            if(this.farmingSelected !== null){
                harvestFilters.farming = this.farmingSelected['id']
            }
            if(this.filtersInsuranceFarmingSelected !== null){
                harvestFilters.insurance_farming = this.filtersInsuranceFarmingSelected['id']
            }
            if(this.closingConditionSelected !== null){
                harvestFilters.closing_condition = this.closingConditionSelected['id']
            }

            return harvestFilters
        }
    }

   
}
